import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ServerTokenService } from '../../services/server-token.service';
import { FaxToEmailMapping } from './fax-to-email.models';

@Injectable({ providedIn: 'root' })
export class FaxToEmailService {
  private readonly base = 'snfai-admin/fax-to-email';

  constructor(private server: ServerTokenService) {}

  getAll(): Observable<FaxToEmailMapping[]> {
    return this.server.getWithToken<FaxToEmailMapping[]>(this.base);
  }

  getByRegion(regionId: number): Observable<FaxToEmailMapping[]> {
    return this.server.getWithToken<FaxToEmailMapping[]>(`${this.base}/region/${regionId}`);
  }

  create(payload: {
    facilityId: number;
    regionId: number;
    email: string;
    siteName?: string;
  }): Observable<FaxToEmailMapping> {
    return this.server.postWithToken<FaxToEmailMapping>(this.base, payload);
  }

  update(
    id: string,
    payload: { facilityId?: number; regionId?: number; email?: string; siteName?: string },
  ): Observable<FaxToEmailMapping> {
    return this.server.putWithToken<FaxToEmailMapping>(`${this.base}/${id}`, payload);
  }

  delete(id: string): Observable<{ message: string }> {
    return this.server.deleteWithToken<{ message: string }>(`${this.base}/${id}`);
  }
}
